module.exports = {
    "name": "Post CORONA",
    "children": [
        {
            "name": "\u754c\u9762\u8f38\u9001\u5de5\u5b66",
            "children": [
                {
                    "name": "\u7a7a\u6c17\u306e\u30de\u30cd\u30b8\u30e1\u30f3\u30c8",
                    "children": [
                        {
                            "name": "\u81ea\u52d5\u30af\u30ea\u30fc\u30cb\u30f3\u30b0\u30eb\u30fc\u30e0",
                            "value": 10,
                            "description": "\u58c1\u3084\u5e8a\u304c\u7a7a\u6c17\u306e\u6d41\u308c\u3092\u4f5c\u308a\u307b\u3053\u308a\u3092\u6d6e\u304b\u305b\u3066\u81ea\u52d5\u7684\u306b\u6383\u9664\u3059\u308b\u90e8\u5c4b",
                            "image": "post_Automatic_cleaning_room_trim.jpg",
                            "card_id": "P1",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#cleaning",
                                        "#room",
                                        "#architecture"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "\u547c\u5438\u3059\u308b\u5efa\u7bc9",
                            "value": 10,
                            "description": "\u81ea\u3089\u3092\u5909\u5f62\u3055\u305b\u3066\u7a7a\u6c17\u3092\u63db\u6c17\u3059\u308b\u5efa\u7269",
                            "image": "post_Breathable_Architecture_trim.jpg",
                            "card_id": "P2",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#air",
                                        "#architecture",
                                        "#ventilation"
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "\u7a7a\u6c17\u306e\u30af\u30aa\u30ea\u30c6\u30a3",
                    "children": [
                        {
                            "name": "\u30c7\u30b6\u30a4\u30f3\u3055\u308c\u305f\u98a8",
                            "value": 10,
                            "description": "\u30e1\u30f3\u30bf\u30eb\u30d8\u30eb\u30b9\u304c\u6539\u5584\u3059\u308b\u3088\u3046\u306b\u30c7\u30b6\u30a4\u30f3\u3055\u308c\u305f\u5feb\u9069\u306a\u98a8",
                            "image": "post_Designed_Wind_trim.jpg",
                            "card_id": "P3",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#air",
                                        "#wind",
                                        "#mental_health"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "\u30d7\u30e9\u30a4\u30d9\u30fc\u30c8\u30a8\u30a2\u30fc\u30b9\u30da\u30fc\u30b9",
                            "value": 10,
                            "description": "\u907f\u96e3\u6240\u3067\u4ed6\u4eba\u306e\u81ed\u3044\u3092\u907f\u3051\u5404\u500b\u4eba\u306e\u7a7a\u9593\u3092\u7dad\u6301\u3067\u304d\u308b\u30a8\u30a2\u30b3\u30f3",
                            "image": "post_Private_Air_Space_trim.jpg",
                            "card_id": "P4",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#air",
                                        "#shelter",
                                        "#well_being"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "\u5e8a\u30a8\u30a2\u30b3\u30f3",
                            "value": 10,
                            "description": "\u5e8a\u6696\u623f\u306e\u3088\u3046\u306b\u67d4\u3089\u304b\u304f\u5e8a\u304b\u3089\u5439\u304f\u98a8",
                            "image": "post_Floor_Air_Conditioner_trim.jpg",
                            "card_id": "P5",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#air",
                                        "#wind",
                                        "#architecture"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "\u732b\u30a2\u30ec\u30eb\u30b2\u30f3\u5438\u7740\u30ed\u30dc\u30c3\u30c8",
                            "value": 10,
                            "description": "\u732b\u30a2\u30ec\u30eb\u30b2\u30f3\u3092\u5438\u7740\u30fb\u53ce\u96c6\u3059\u308b\u81ea\u5f8b\u578b\u732b\u30ed\u30dc\u30c3\u30c8",
                            "image": "post_Cat_allergen_adsorption_robot_trim.jpg",
                            "card_id": "P49",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#cleaning",
                                        "#room",
                                        "#well_being"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "\u82b1\u7c89\u75c7\u5bfe\u7b56\u5efa\u7bc9",
                            "value": 10,
                            "description": "\u5168\u3066\u306e\u30a4\u30f3\u30c6\u30ea\u30a2\u304c\u82b1\u7c89\u3092\u5438\u5f15\u3057\u30a2\u30ec\u30eb\u30ae\u30fc\u75c7\u72b6\u7121\u304f\u66ae\u3089\u3059\u3053\u3068\u304c\u3067\u304d\u308b\u5bb6",
                            "image": "post_Against_Pollinosis_Architecture_trim.jpg",
                            "card_id": "P50",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#cleaning",
                                        "#room",
                                        "#well_being"
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "\u6c34\u306e\u6d41\u308c\u306e\u30de\u30cd\u30b8\u30e1\u30f3\u30c8",
                    "children": [
                        {
                            "name": "\u30de\u30a4\u30af\u30ed\u30d7\u30e9\u30b9\u30c1\u30c3\u30af\u30ad\u30e3\u30c3\u30c1\u30e3\u30fc",
                            "value": 10,
                            "description": "\u30de\u30a4\u30af\u30ed\u30d7\u30e9\u30b9\u30c1\u30c3\u30af\u3092\u96c6\u3081\u308b\u305f\u3081\u306b\u6d77\u306b\u6c34\u6d41\u3092\u4f5c\u308a\u51fa\u3059\u7269\u7406\u30b7\u30b9\u30c6\u30e0",
                            "image": "post_Micro_Plastics_Catcher_trim.jpg",
                            "card_id": "P6",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#water",
                                        "#ocean",
                                        "#micro_plastics"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "name": "\u30de\u30a4\u30af\u30ed\u8981\u7d20\u69cb\u6210\u5b66",
            "children": [
                {
                    "name": "\u4f53\u6db2\u30c7\u30fc\u30bf\u306e\u6d3b\u7528",
                    "children": [
                        {
                            "name": "\u30b9\u30de\u30fc\u30c8\u30d1\u30c3\u30c1\u30a6\u30a9\u30c3\u30c1",
                            "value": 10,
                            "description": "\u8eab\u4f53\u30c7\u30fc\u30bf\u3092\u53ce\u96c6\u3067\u304d\u308b\u30de\u30a4\u30af\u30ed\u30cb\u30fc\u30c9\u30eb\u30d1\u30c3\u30c1\u3068\u7d71\u5408\u3055\u308c\u305f\u30b9\u30de\u30fc\u30c8\u30a6\u30a9\u30c3\u30c1",
                            "image": "post_Smart_Patch_Watch_trim.jpg",
                            "card_id": "P7",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#watch",
                                        "#well_being",
                                        "#mental_health"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "\u5065\u5eb7\u7ba1\u7406\u30b3\u30b9\u30e1",
                            "value": 10,
                            "description": "\u30a2\u30a4\u30b7\u30e3\u30c9\u30a6\u3068\u3057\u3066\u4f7f\u7528\u3067\u304d\u808c\u306e\u72b6\u614b\u306e\u30c7\u30fc\u30bf\u3082\u53ce\u96c6\u3067\u304d\u308b\u30d1\u30c3\u30c1",
                            "image": "post_Health_Check_Cosmetic_trim.jpg",
                            "card_id": "P8",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#skin",
                                        "#cosmetic",
                                        "#well_being"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "\u611f\u60c5\u691c\u51fa\u30d1\u30c3\u30c1",
                            "value": 10,
                            "description": "\u4f53\u6db2\u306e\u30c7\u30fc\u30bf\u304b\u3089\u611f\u60c5\u3092\u691c\u51fa\u3067\u304d\u308b\u30de\u30a4\u30af\u30ed\u30cb\u30fc\u30c9\u30eb\u30d1\u30c3\u30c1",
                            "image": "post_Emotion_detection_Patch_trim.jpg",
                            "card_id": "P9",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#skin",
                                        "#mental_health",
                                        "#emotion"
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "\u65b0\u30de\u30a4\u30af\u30ed\u30cb\u30fc\u30c9\u30eb\u6d3b\u7528\u6cd5",
                    "children": [
                        {
                            "name": "\u7cd6\u5c3f\u75c5\u7528\u30de\u30a4\u30af\u30ed\u30cb\u30fc\u30c9\u30eb",
                            "value": 10,
                            "description": "\u7cd6\u5c3f\u75c5\u60a3\u8005\u306b\u30a4\u30f3\u30b9\u30ea\u30f3\u3092\u7121\u75db\u3067\u88dc\u5145\u3057\u8840\u7cd6\u5024\u3092\u4e0b\u3052\u308b",
                            "image": "post_Micro-needle_for_diabetes_trim.jpg",
                            "card_id": "P10",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#skin",
                                        "#painless",
                                        "#diabetes"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "\u30de\u30a4\u30af\u30ed\u30cb\u30fc\u30c9\u30eb\u30b7\u30fc\u30c8",
                            "value": 10,
                            "description": "\u5404\u81ea\u30ab\u30c3\u30c8\u3057\u3066\u500b\u5225\u306e\u6295\u4e0e\u91cf\u304c\u53d6\u308c\u308b\u30de\u30a4\u30af\u30ed\u30cb\u30fc\u30c9\u30eb\u30d1\u30c3\u30c1\u30b7\u30fc\u30c8",
                            "image": "post_Micro_needle sheet_trim.jpg",
                            "card_id": "P11",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#skin",
                                        "#habit",
                                        "#dosage"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "\u30de\u30a4\u30af\u30ed\u30cb\u30fc\u30c9\u30eb\u9999\u6c34",
                            "value": 10,
                            "description": "\u9999\u308a\u306e\u826f\u3044\u30a8\u30c3\u30bb\u30f3\u30b7\u30e3\u30eb\u30aa\u30a4\u30eb\u304c\u808c\u306b\u6d78\u900f\u3059\u308b\u30de\u30a4\u30af\u30ed\u30cb\u30fc\u30c9\u30eb\u30d1\u30c3\u30c1",
                            "image": "post_Micro_needle_perfume_trim.jpg",
                            "card_id": "P12",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#skin",
                                        "#fashion",
                                        "#well_being"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "\u30de\u30a4\u30af\u30ed\u30cb\u30fc\u30c9\u30eb\u30bf\u30c8\u30a5\u30fc",
                            "value": 10,
                            "description": "\u4e00\u6642\u7684\u306a\u30d5\u30a1\u30c3\u30b7\u30e7\u30f3\u30bf\u30c8\u30a5\u30fc\u3068\u3057\u3066\u4f7f\u7528\u3067\u304d\u308b\u30de\u30a4\u30af\u30ed\u30cb\u30fc\u30c9\u30eb",
                            "image": "post_Micto_Needle_Tattoo_trim.jpg",
                            "card_id": "P13",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#skin",
                                        "#fashion",
                                        "#tatoo"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "\u690d\u7269\u7528\u30de\u30a4\u30af\u30ed\u30cb\u30fc\u30c9\u30eb",
                            "value": 10,
                            "description": "\u690d\u7269\u306e\u72b6\u614b\u3092\u7ba1\u7406\u3067\u304d\u308b\u690d\u7269\u7528\u30de\u30a4\u30af\u30ed\u30cb\u30fc\u30c9\u30eb\u30d1\u30c3\u30c1",
                            "image": "post_Micro_needle_for_Plants_trim.jpg",
                            "card_id": "P14",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#plant",
                                        "#tree",
                                        "#health"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "name": "\u533b\u7528\u30d0\u30a4\u30aa\u5de5\u5b66",
            "children": [
                {
                    "name": "\u81ea\u5b85\u30d8\u30eb\u30b9\u30b1\u30a2",
                    "children": [
                        {
                            "name": "\u30d8\u30eb\u30b9\u30d5\u30a9\u30fc\u30ad\u30e3\u30b9\u30c8",
                            "value": 10,
                            "description": "\u6bdb\u7d30\u8840\u7ba1\u30c7\u30fc\u30bf\u3092\u8a08\u6e2c\u3057\u5065\u5eb7\u72b6\u614b\u3092\u4e88\u6e2c\u3059\u308b\u5065\u5eb7\u4e88\u5831",
                            "image": "post_Health_Forecast_trim.jpg",
                            "card_id": "P15",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#health_care",
                                        "#daily_routine",
                                        "#data"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "\u547c\u6c17\u5065\u5eb7\u30b9\u30ad\u30e3\u30f3",
                            "value": 10,
                            "description": "\u547c\u6c17\u3092\u4f7f\u7528\u3057\u305d\u306e\u5316\u5b66\u7d44\u6210\u3092\u6e2c\u5b9a\u3059\u308b\u3053\u3068\u306b\u3088\u308b\u5065\u5eb7\u30b9\u30ad\u30e3\u30f3",
                            "image": "post_Breath_Health_Scan_trim.jpg",
                            "card_id": "P23",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#breath",
                                        "#air",
                                        "#health_care"
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "\u4f1a\u8a71\u304c\u3044\u3089\u306a\u3044\u5065\u5eb7\u6e2c\u5b9a",
                    "children": [
                        {
                            "name": "\u52d5\u7269\u7528\u6bdb\u7d30\u8840\u7ba1\u5065\u5eb7\u30c1\u30a7\u30c3\u30ab\u30fc",
                            "value": 10,
                            "description": "\u6bdb\u7d30\u8840\u7ba1\u3067\u5065\u5eb7\u30c1\u30a7\u30c3\u30af\u304c\u3067\u304d\u308b\u52d5\u7269\u7528\u5065\u5eb7\u6e2c\u5b9a\u5668",
                            "image": "post_Animal_Capillary_Health_Checker_trim.jpg",
                            "card_id": "P16",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#animal",
                                        "#health",
                                        "#remote"
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "\u5065\u5eb7\u30ea\u30c6\u30e9\u30b7\u30fc",
                    "children": [
                        {
                            "name": "\u30bb\u30eb\u30d5\u5065\u5eb7\u30c1\u30a7\u30c3\u30af\u30c8\u30ec\u30fc\u30cb\u30f3\u30b0",
                            "value": 10,
                            "description": "\u672c\u6765\u306e\u5065\u5eb7\u72b6\u614b\u3092\u4f53\u306e\u81ea\u899a\u75c7\u72b6\u304b\u3089\u77e5\u308b\u30bb\u30eb\u30d5\u5065\u5eb7\u30c1\u30a7\u30c3\u30af\u30c8\u30ec\u30fc\u30cb\u30f3\u30b0",
                            "image": "post_Self_Health_Check_Training_trim.jpg",
                            "card_id": "P17",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#health_care",
                                        "#habit",
                                        "#daily_routines"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "\u8840\u7ba1\u306e\u5065\u5eb7\u72b6\u614b\u306e\u65b0\u5358\u4f4d",
                            "value": 10,
                            "description": "\u8840\u7ba1\u306e\u5065\u5eb7\u306e\u91cd\u8981\u6027\u3092\u4f1d\u3048\u308b\u305f\u3081\u306e\u8840\u6d41\u306e\u5358\u4f4d(\u4f8b: cc / s\u30fb\u7c98\u5ea6)",
                            "image": "post_New_unit_of_Capillary_Health_trim.jpg",
                            "card_id": "P18",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#health_care",
                                        "#habit",
                                        "#communication"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "\u8840\u7ba1\u306e\u5065\u5eb7\u72b6\u614b\u3092\u8868\u3059\u65b0\u5358\u8a9e",
                            "value": 10,
                            "description": "\u81ea\u5206\u306e\u5065\u5eb7\u72b6\u614b\u3092\u5224\u65ad\u3057\u81ea\u5df1\u8a8d\u8b58\u3092\u9ad8\u3081\u308b\u305f\u3081\u306e\u65b0\u3057\u3044\u8a00\u8449(\u4f8b: \u8840\u7ba1\u7f8e\u4eba\uff09",
                            "image": "post_New_words_of_Capillary_Health_trim.jpg",
                            "card_id": "P19",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#health_care",
                                        "#habit",
                                        "#communication"
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "\u8840\u7ba1\u30c7\u30fc\u30bf\u306e\u591a\u76ee\u7684\u5229\u7528",
                    "children": [
                        {
                            "name": "\u7cd6\u5c3f\u75c5\u7528\u8840\u7ba1\u6e2c\u5b9a",
                            "value": 10,
                            "description": "\u7cd6\u5c3f\u75c5\u3092\u898b\u3064\u3051\u308b\u6bdb\u7d30\u8840\u7ba1\u30e2\u30cb\u30bf\u30ea\u30f3\u30b0\u30b7\u30b9\u30c6\u30e0",
                            "image": "post_Capillary_Monitoring_for_diabetes_trim.jpg",
                            "card_id": "P20",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#diabetes",
                                        "#data",
                                        "#painless"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "\u8840\u7ba1\u30c8\u30fc\u30af",
                            "value": 10,
                            "description": "\u6bdb\u7d30\u8840\u7ba1\u306e\u5199\u771f\u3092\u30ad\u30e3\u30e9\u30af\u30bf\u30fc\u5316\u3057\u305f\u30b3\u30df\u30e5\u30cb\u30b1\u30fc\u30b7\u30e7\u30f3\u30c4\u30fc\u30eb",
                            "image": "post_Capillary_Talk_trim.jpg",
                            "card_id": "P21",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#data_visualisation",
                                        "#relationship",
                                        "#communication"
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "\u6bdb\u7d30\u8840\u7ba1\u6e2c\u5b9a\u65b9\u6cd5",
                    "children": [
                        {
                            "name": "\u8840\u7ba1\u6e2c\u5b9a\u30e1\u30ac\u30cd",
                            "value": 10,
                            "description": "\u773c\u5e95\u6bdb\u7d30\u8840\u7ba1\u306e\u72b6\u614b\u3092\u6e2c\u5b9a\u3057\u5065\u5eb7\u30c7\u30fc\u30bf\u3092\u4fdd\u5b58\u3067\u304d\u308b\u30e1\u30ac\u30cd",
                            "image": "post_Eyeglasses_Measuring_Capillaries_trim.jpg",
                            "card_id": "P22",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#data",
                                        "#health_care",
                                        "#wearable"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "name": "\u8d85\u9ad8\u901f\u5149\u5b66",
            "children": [
                {
                    "name": "\u81ea\u5b85\u30d8\u30eb\u30b9\u30b1\u30a2",
                    "children": [
                        {
                            "name": "\u30d8\u30eb\u30b9\u30d5\u30a9\u30fc\u30ad\u30e3\u30b9\u30c8",
                            "value": 10,
                            "description": "\u6bdb\u7d30\u8840\u7ba1\u30c7\u30fc\u30bf\u3092\u8a08\u6e2c\u3057\u5065\u5eb7\u72b6\u614b\u3092\u4e88\u6e2c\u3059\u308b\u5065\u5eb7\u4e88\u5831",
                            "image": "post_Health_Forecast_trim.jpg",
                            "card_id": "P15",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#health_care",
                                        "#daily_routine",
                                        "#data"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "\u547c\u6c17\u5065\u5eb7\u30b9\u30ad\u30e3\u30f3",
                            "value": 10,
                            "description": "\u547c\u6c17\u3092\u4f7f\u7528\u3057\u305d\u306e\u5316\u5b66\u7d44\u6210\u3092\u6e2c\u5b9a\u3059\u308b\u3053\u3068\u306b\u3088\u308b\u5065\u5eb7\u30b9\u30ad\u30e3\u30f3",
                            "image": "post_Breath_Health_Scan_trim.jpg",
                            "card_id": "P23",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#breath",
                                        "#air",
                                        "#health_care"
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "\u898b\u3048\u306a\u3044\u5371\u967a\u3092\u691c\u51fa",
                    "children": [
                        {
                            "name": "\u5927\u6c17\u6c5a\u67d3\u30e2\u30cb\u30bf\u30ea\u30f3\u30b0",
                            "value": 10,
                            "description": "\u5927\u6c17\u6c5a\u67d3\u306e\u30e2\u30cb\u30bf\u30ea\u30f3\u30b0(NOx/\u7a92\u7d20\u9178\u5316\u7269\u30fbSOx/\u786b\u9ec4\u9178\u5316\u7269)",
                            "image": "post_Air_pollution_monitoring_trim.jpg",
                            "card_id": "P24",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#environment",
                                        "#air",
                                        "#monitoring"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "\u4e00\u9178\u5316\u70ad\u7d20\u4e2d\u6bd2\u691c\u51fa\u5668",
                            "value": 10,
                            "description": "\u4e00\u9178\u5316\u70ad\u7d20\u4e2d\u6bd2\u3092\u691c\u51fa\u3059\u308b\u8a08\u6e2c\u5668(\u4f8b: \u90e8\u5c4b/\u81ea\u52d5\u8eca)",
                            "image": "post_Carbon_Monoxide_Poisoning_Detector_trim.jpg",
                            "card_id": "P25",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#air",
                                        "#detection",
                                        "#danger"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "\u6392\u6c17\u30ac\u30b9\u30e2\u30cb\u30bf\u30ea\u30f3\u30b0",
                            "value": 10,
                            "description": "\u6392\u6c17\u30ac\u30b9\u306e\u54c1\u8cea\u3092\u76e3\u8996\u3059\u308b\u305f\u3081\u306b\u8eca\u4e21\u306b\u53d6\u308a\u4ed8\u3051\u3089\u308c\u308b\u6e2c\u5b9a\u5668",
                            "image": "post_Exhaust_Gas_Monitoring_trim.jpg",
                            "card_id": "P26",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#climate_change",
                                        "#air",
                                        "#detection"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "\u98df\u4e2d\u6bd2\u691c\u51fa\u5668",
                            "value": 10,
                            "description": "\u98df\u4e2d\u6bd2\u306e\u539f\u56e0\u83cc\u3092\u691c\u77e5\u3059\u308b\u30bb\u30f3\u30b5\u30fc",
                            "image": "post_Food_Poisoning_Detector_trim.jpg",
                            "card_id": "P27",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#food",
                                        "#detection",
                                        "#danger"
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "\u898b\u3048\u306a\u3044\u6709\u76ca\u60c5\u5831\u3092\u691c\u51fa",
                    "children": [
                        {
                            "name": "\u690d\u7269\u9593\u30b3\u30df\u30e5\u30cb\u30b1\u30fc\u30b7\u30e7\u30f3\u691c\u51fa\u5668",
                            "value": 10,
                            "description": "\u690d\u7269\u304b\u3089\u7a7a\u6c17\u4e2d\u3078\u76f8\u4e92\u901a\u4fe1\u306e\u305f\u3081\u306b\u653e\u51fa\u3055\u308c\u305f\u5316\u5b66\u7269\u8cea\u3092\u691c\u51fa\u3059\u308b\u690d\u6728\u9262",
                            "image": "post_Plants_Communication_Detector_trim.jpg",
                            "card_id": "P28",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#air",
                                        "#detection",
                                        "#biology"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "\u30d5\u30a7\u30ed\u30e2\u30f3\u691c\u77e5\u5668",
                            "value": 10,
                            "description": "\u7d76\u6ec5\u5371\u60e7\u7a2e\u306e\u7e41\u6b96\u671f\u306e\u30d5\u30a7\u30ed\u30e2\u30f3\u3092\u691c\u77e5\u3057\u3066\u9069\u5207\u306a\u7e41\u6b96\u3092\u52a9\u3051\u308b",
                            "image": "post_Pheromone_Detector_trim.jpg",
                            "card_id": "P29",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#air",
                                        "#detection",
                                        "#biology"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "name": "\u540c\u4f4d\u4f53\u6c17\u8c61\u5b66",
            "children": [
                {
                    "name": "\u6df7\u96d1\u306e\u8996\u899a\u5316",
                    "children": [
                        {
                            "name": "\u907f\u96e3\u6240\u30ac\u30a4\u30c9",
                            "value": 10,
                            "description": "\u907f\u96e3\u79fb\u52d5\u3092\u8ffd\u8de1\u3057\u3066\u907f\u96e3\u6240\u306e\u30ad\u30e3\u30d1\u30b7\u30c6\u30a3\u3092\u4e88\u60f3\u3059\u308b\u30a2\u30d7\u30ea",
                            "image": "post_Shelter_guide_trim.jpg",
                            "card_id": "P30",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#shelter",
                                        "#data_visualisation",
                                        "#congestion"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "\u4ea4\u901a\uff06CO2 \u30a4\u30f3\u30d1\u30af\u30c8\u30de\u30c3\u30d7",
                            "value": 10,
                            "description": "\u4ea4\u901a\u6e0b\u6ede\u3068CO2\u30ec\u30d9\u30eb\u3092\u540c\u6642\u306b\u53ef\u8996\u5316\u30fb\u8868\u793a\u3059\u308b\u6c11\u9593\u79d1\u5b66\u30d7\u30e9\u30c3\u30c8\u30d5\u30a9\u30fc\u30e0",
                            "image": "post_Traffic_CO2_Impact_Map_trim.jpg",
                            "card_id": "P31",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#congestion",
                                        "#data_visualisation",
                                        "#climate_change"
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "\u74b0\u5883\u5f71\u97ff\u30ea\u30c6\u30e9\u30b7\u30fc",
                    "children": [
                        {
                            "name": "CO2 \u30bf\u30b0",
                            "value": 10,
                            "description": "\u5546\u54c1\u3092\u751f\u7523\u3059\u308b\u969b\u306b\u6392\u51fa\u3057\u305fCO2\u91cf\u3092\u8868\u793a\u3059\u308b\u30bf\u30b0",
                            "image": "post_CO2_Tag_trim.jpg",
                            "card_id": "P32",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#air",
                                        "#communication",
                                        "#climate_change"
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "\u74b0\u5883\u30c7\u30fc\u30bf\u306e\u6d3b\u7528",
                    "children": [
                        {
                            "name": "\u30d5\u30fc\u30c9\u30ed\u30b9\u30ab\u30c3\u30bf\u30fc",
                            "value": 10,
                            "description": "\u98df\u54c1\u5ec3\u68c4\u7269\u3092\u524a\u6e1b\u3059\u308b\u305f\u3081\u306e\u74b0\u5883\u30c7\u30fc\u30bf\u5206\u6790\u306b\u3088\u308b\u98df\u54c1\u9700\u8981\u4e88\u6e2c",
                            "image": "post_Food_Loss_Cutter_trim.jpg",
                            "card_id": "P33",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#food",
                                        "#prediction",
                                        "#climate_change"
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "\u53e4\u4ee3\u30c7\u30fc\u30bf\u306e\u6d3b\u7528",
                    "children": [
                        {
                            "name": "\u707d\u5bb3\u672a\u6765\u30ab\u30ec\u30f3\u30c0\u30fc",
                            "value": 10,
                            "description": "\u904e\u53bb\u306e\u707d\u5bb3\u306e\u6642\u671f\u30fb\u983b\u5ea6\u30c7\u30fc\u30bf\u304b\u3089\u4f5c\u6210\u3057\u305f\u707d\u5bb3\u4e88\u6e2c\u672a\u6765\u30ab\u30ec\u30f3\u30c0\u30fc",
                            "image": "post_Future_Disaster_Calendar_trim.jpg",
                            "card_id": "P34",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#prediction",
                                        "#disaster",
                                        "#climate_change"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "\u53e4\u4ee3\u8a00\u8a9e\u7ffb\u8a33\u6a5f",
                            "value": 10,
                            "description": "\u53e4\u4ee3\u306e\u6587\u66f8\u3092\u73fe\u4ee3\u8a9e\u306b\u7ffb\u8a33\u3067\u304d\u308b\u7ffb\u8a33\u6a5f",
                            "image": "post_Ancient_Language_Translator_trim.jpg",
                            "card_id": "P35",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#climate_change",
                                        "#linguistics",
                                        "#history"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "name": "\u30d7\u30ed\u30b8\u30a7\u30af\u30c8\u30fb\u30de\u30cd\u30b8\u30e1\u30f3\u30c8\u5b66",
            "children": [
                {
                    "name": "\u7269\u7406\u7684\u5b58\u5728\u306e\u4fa1\u5024",
                    "children": [
                        {
                            "name": "\u30d0\u30fc\u30c1\u30e3\u30ebCEO",
                            "value": 10,
                            "description": "CEO\u306e\u7269\u7406\u7684\u306a\u5b58\u5728\u611f\u3092\u30d7\u30ed\u30c7\u30e5\u30fc\u30b9\u3067\u304d\u308b\u30a2\u30f3\u30c9\u30ed\u30a4\u30c9",
                            "image": "post_Virtual_CEO_trim.jpg",
                            "card_id": "P36",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#virtual",
                                        "#communication",
                                        "#presence"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "\u30d0\u30fc\u30c1\u30e3\u30eb\u8b66\u5099\u54e1",
                            "value": 10,
                            "description": "\u4eba\u306e\u5b58\u5728\u3092\u691c\u51fa\u3057\u9632\u72af\u3059\u308b\u76ee\u306b\u898b\u3048\u308b\u30d0\u30fc\u30c1\u30e3\u30eb\u8b66\u5099\u54e1",
                            "image": "post_Virtual_Security_Guard_trim.jpg",
                            "card_id": "P37",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#virtual",
                                        "#crime_prevention",
                                        "#presence"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "name": "\u90fd\u5e02\u30a8\u30cd\u30eb\u30ae\u30fc\u5de5\u5b66",
            "children": [
                {
                    "name": "\u7a4d\u6975\u7684\u306b\u826f\u3044\u7a7a\u6c17\u3092\u4f5c\u308b",
                    "children": [
                        {
                            "name": "\u9178\u7d20\u30ac\u30e0",
                            "value": 10,
                            "description": "\u565b\u3080\u3053\u3068\u3067\u9178\u7d20\u3092\u751f\u6210\u3067\u304d\u308b\u30ac\u30e0",
                            "image": "post_Oxygen_Gum_trim.jpg",
                            "card_id": "P38",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#air",
                                        "#breath",
                                        "#health"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "name": "\u4eba\u9593\u90fd\u5e02\u60c5\u5831\u5b66",
            "children": [
                {
                    "name": "\u65b0\u3057\u3044\u50cd\u304d\u65b9",
                    "children": [
                        {
                            "name": "\u5c31\u696d\u65e5\u306e\u65b0\u3057\u3044\u5b9a\u7fa9",
                            "value": 10,
                            "description": "\u5c31\u696d\u65e5\u306e\u65b0\u3057\u3044\u5b9a\u7fa9\u3002\u300c\u5e73\u65e5/\u9031\u672b\u300d\u304b\u3089\u300c\u30aa\u30f3\u30e9\u30a4\u30f3\u65e5/\u30aa\u30d5\u30e9\u30a4\u30f3\u65e5\u300d",
                            "image": "post_New_Working_Days_trim.jpg",
                            "card_id": "P39",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#mental_health",
                                        "#well_being",
                                        "#habit"
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "\u5e0c\u671b\u306e\u53ef\u8996\u5316",
                    "children": [
                        {
                            "name": "\u3088\u308a\u826f\u3044\u672a\u6765\u306e\u30ac\u30a4\u30c9",
                            "value": 10,
                            "description": "\u90fd\u5e02\u304b\u3089\u53d6\u5f97\u3057\u305f\u30c7\u30fc\u30bf\u3092\u89e3\u6790\u3057SDGs\u306e\u9054\u6210\u5ea6\u3092\u793a\u3059\u30d7\u30e9\u30c3\u30c8\u30d5\u30a9\u30fc\u30e0",
                            "image": "post_Guide_of_Better_Future_trim.jpg",
                            "card_id": "P40",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#public",
                                        "#well_being",
                                        "#communication"
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "AI \u00d7 \u53ef\u8996\u5316",
                    "children": [
                        {
                            "name": "\u671b\u307f\u30b3\u30f3\u30b7\u30a7\u30eb\u30b8\u30e5",
                            "value": 10,
                            "description": "\u3069\u306e\u3088\u3046\u306a\u5e0c\u671b\u304c\u9054\u6210\u53ef\u80fd\u3067\u7406\u60f3\u3068\u3059\u308b\u4eba\u751f\u306b\u8fd1\u3044\u304b\u3092\u30a2\u30c9\u30d0\u30a4\u30b9\u3059\u308b\u30a2\u30d7\u30ea",
                            "image": "post_Hope_Concierge_trim.jpg",
                            "card_id": "P41",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#mental_health",
                                        "#well_being",
                                        "#daily_routine"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "name": "\u30a4\u30f3\u30bf\u30e9\u30af\u30c6\u30a3\u30d6\u8996\u899a\u77e5\u80fd",
            "children": [
                {
                    "name": "\u8996\u899a\u4f53\u9a13",
                    "children": [
                        {
                            "name": "\u4f53\u611f\u30e2\u30cb\u30bf\u30fc",
                            "value": 10,
                            "description": "\u9ad8\u9f62\u8005\u306e\u8996\u899a\u60c5\u5831\u3092\u4f53\u9a13\u3057\u306a\u304c\u3089\u5b89\u5168\u3092\u76e3\u8996\u3059\u308bVR\u30e2\u30cb\u30bf\u30fc",
                            "image": "post_Experience_Monitor_trim.jpg",
                            "card_id": "P42",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#privacy",
                                        "#virtual",
                                        "#remote"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "Online\u30b3\u30df\u30e5\u30cb\u30b1\u30fc\u30b7\u30e7\u30f3\u30de\u30cd\u30b8\u30e3\u30fc",
                            "value": 10,
                            "description": "\u30aa\u30f3\u30e9\u30a4\u30f3\u753b\u50cf\u306e\u8996\u7dda\u304c\u76f8\u624b\u3068\u5408\u3046\u3088\u3046\u306b\u81ea\u52d5\u7684\u306b\u8abf\u6574\u3055\u308c\u308b\u30a2\u30d7\u30ea",
                            "image": "post_Online_Communication_Manager_trim.jpg",
                            "card_id": "P43",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#communication",
                                        "#remote",
                                        "#presence"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "\u8077\u4eba\u306e\u8996\u7dda\u30a2\u30fc\u30ab\u30a4\u30d6",
                            "value": 10,
                            "description": "\u4f1d\u7d71\u82b8\u80fd\u8077\u4eba\u306e\u8996\u7dda\u3092\u8996\u899a\u4f53\u9a13\u3068\u3057\u3066\u4f53\u611f\u3067\u304d\u308b\u30a2\u30fc\u30ab\u30a4\u30d6",
                            "image": "post_Artisans_Line_of_Sight_Archive_trim.jpg",
                            "card_id": "P44",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#detection",
                                        "#habit",
                                        "#virtual"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "\u89e6\u611f\u5730\u56f3\u6848\u5185",
                            "value": 10,
                            "description": "\u8996\u899a\u969c\u5bb3\u306e\u4eba\u306e\u305f\u3081\u306e\u8d85\u97f3\u6ce2\u89e6\u611f\u30d5\u30a3\u30fc\u30c9\u30d0\u30c3\u30af\u306b\u3088\u308b\u5730\u56f3\u6848\u5185",
                            "image": "post_Tactile_Map_Guide_trim.jpg",
                            "card_id": "P46",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#interface",
                                        "#tactile",
                                        "#communication"
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "\u30bf\u30c3\u30c1\u30ec\u30b9\u30b3\u30df\u30e5\u30cb\u30b1\u30fc\u30b7\u30e7\u30f3",
                    "children": [
                        {
                            "name": "\u30a6\u30a3\u30f3\u30af\u30ad\u30e3\u30c3\u30c1\u30e3\u30fc",
                            "value": 10,
                            "description": "\u8996\u7dda\u3092\u6349\u3048\u8ab0\u304c\u8208\u5473\u3092\u6301\u3063\u3066\u3044\u308b\u304b\u3092\u7279\u5b9a\u3059\u308b\u30a2\u30af\u30bb\u30b5\u30ea\u30fc(\u30a4\u30d9\u30f3\u30c8/\u9632\u72af)",
                            "image": "post_Wink Catcher_trim.jpg",
                            "card_id": "P45",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#crime_prevention",
                                        "#gathering",
                                        "#communication"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "name": "\u8996\u899a\u30e1\u30c7\u30a3\u30a2\u5de5\u5b66",
            "children": [
                {
                    "name": "\u8996\u899a\u4f53\u9a13",
                    "children": [
                        {
                            "name": "\u4f53\u611f\u30e2\u30cb\u30bf\u30fc",
                            "value": 10,
                            "description": "\u9ad8\u9f62\u8005\u306e\u8996\u899a\u60c5\u5831\u3092\u4f53\u9a13\u3057\u306a\u304c\u3089\u5b89\u5168\u3092\u76e3\u8996\u3059\u308bVR\u30e2\u30cb\u30bf\u30fc",
                            "image": "post_Experience_Monitor_trim.jpg",
                            "card_id": "P42",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#privacy",
                                        "#virtual",
                                        "#remote"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "Online\u30b3\u30df\u30e5\u30cb\u30b1\u30fc\u30b7\u30e7\u30f3\u30de\u30cd\u30b8\u30e3\u30fc",
                            "value": 10,
                            "description": "\u30aa\u30f3\u30e9\u30a4\u30f3\u753b\u50cf\u306e\u8996\u7dda\u304c\u76f8\u624b\u3068\u5408\u3046\u3088\u3046\u306b\u81ea\u52d5\u7684\u306b\u8abf\u6574\u3055\u308c\u308b\u30a2\u30d7\u30ea",
                            "image": "post_Online_Communication_Manager_trim.jpg",
                            "card_id": "P43",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#communication",
                                        "#remote",
                                        "#presence"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "\u8077\u4eba\u306e\u8996\u7dda\u30a2\u30fc\u30ab\u30a4\u30d6",
                            "value": 10,
                            "description": "\u4f1d\u7d71\u82b8\u80fd\u8077\u4eba\u306e\u8996\u7dda\u3092\u8996\u899a\u4f53\u9a13\u3068\u3057\u3066\u4f53\u611f\u3067\u304d\u308b\u30a2\u30fc\u30ab\u30a4\u30d6",
                            "image": "post_Artisans_Line_of_Sight_Archive_trim.jpg",
                            "card_id": "P44",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#detection",
                                        "#habit",
                                        "#virtual"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "\u89e6\u611f\u5730\u56f3\u6848\u5185",
                            "value": 10,
                            "description": "\u8996\u899a\u969c\u5bb3\u306e\u4eba\u306e\u305f\u3081\u306e\u8d85\u97f3\u6ce2\u89e6\u611f\u30d5\u30a3\u30fc\u30c9\u30d0\u30c3\u30af\u306b\u3088\u308b\u5730\u56f3\u6848\u5185",
                            "image": "post_Tactile_Map_Guide_trim.jpg",
                            "card_id": "P46",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#interface",
                                        "#tactile",
                                        "#communication"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "name": "\u5efa\u7bc9\u8a2d\u8a08\u5b66",
            "children": [
                {
                    "name": "\u81ea\u5b85\u3067\u306e\u30e1\u30f3\u30bf\u30eb\u30b1\u30a2",
                    "children": [
                        {
                            "name": "\u7cbe\u795e\u3092\u6574\u3048\u308b\u90e8\u5c4b",
                            "value": 10,
                            "description": "\u8133\u6ce2\u306e\u72b6\u614b\u306b\u3088\u3063\u3066\u5185\u88c5\u306e\u8272\u304c\u5909\u308f\u308a\u7cbe\u795e\u3092\u6574\u3048\u308b\u3053\u3068\u304c\u3067\u304d\u308b\u90e8\u5c4b",
                            "image": "post_Mental_Care_Room_trim.jpg",
                            "card_id": "P47",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#room",
                                        "#well_being",
                                        "#architecture"
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "\u30b3\u30df\u30e5\u30cb\u30c6\u30a3\u30de\u30cd\u30fc\u30b8\u30e1\u30f3\u30c8",
                    "children": [
                        {
                            "name": "\u53ce\u7a6b\u304a\u3059\u305d\u308f\u3051\u30a2\u30d7\u30ea",
                            "value": 10,
                            "description": "\u5bb6\u5ead\u83dc\u5712\u3067\u53ce\u7a6b\u3057\u305f\u91ce\u83dc\u3092\u30b7\u30a7\u30a2\u3067\u304d\u308b\u4eba\u3092\u63a2\u305b\u308b\u30a2\u30d7\u30ea",
                            "image": "post_Harvest_Sharing_App_trim.jpg",
                            "card_id": "P48",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#communication",
                                        "#well_being",
                                        "#community"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "name": "\u751f\u7269\u7269\u7406\u5de5\u5b66",
            "children": [
                {
                    "name": "\u7a7a\u6c17\u306e\u30af\u30aa\u30ea\u30c6\u30a3",
                    "children": [
                        {
                            "name": "\u30c7\u30b6\u30a4\u30f3\u3055\u308c\u305f\u98a8",
                            "value": 10,
                            "description": "\u30e1\u30f3\u30bf\u30eb\u30d8\u30eb\u30b9\u304c\u6539\u5584\u3059\u308b\u3088\u3046\u306b\u30c7\u30b6\u30a4\u30f3\u3055\u308c\u305f\u5feb\u9069\u306a\u98a8",
                            "image": "post_Designed_Wind_trim.jpg",
                            "card_id": "P3",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#air",
                                        "#wind",
                                        "#mental_health"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "\u30d7\u30e9\u30a4\u30d9\u30fc\u30c8\u30a8\u30a2\u30fc\u30b9\u30da\u30fc\u30b9",
                            "value": 10,
                            "description": "\u907f\u96e3\u6240\u3067\u4ed6\u4eba\u306e\u81ed\u3044\u3092\u907f\u3051\u5404\u500b\u4eba\u306e\u7a7a\u9593\u3092\u7dad\u6301\u3067\u304d\u308b\u30a8\u30a2\u30b3\u30f3",
                            "image": "post_Private_Air_Space_trim.jpg",
                            "card_id": "P4",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#air",
                                        "#shelter",
                                        "#well_being"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "\u5e8a\u30a8\u30a2\u30b3\u30f3",
                            "value": 10,
                            "description": "\u5e8a\u6696\u623f\u306e\u3088\u3046\u306b\u67d4\u3089\u304b\u304f\u5e8a\u304b\u3089\u5439\u304f\u98a8",
                            "image": "post_Floor_Air_Conditioner_trim.jpg",
                            "card_id": "P5",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#air",
                                        "#wind",
                                        "#architecture"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "\u732b\u30a2\u30ec\u30eb\u30b2\u30f3\u5438\u7740\u30ed\u30dc\u30c3\u30c8",
                            "value": 10,
                            "description": "\u732b\u30a2\u30ec\u30eb\u30b2\u30f3\u3092\u5438\u7740\u30fb\u53ce\u96c6\u3059\u308b\u81ea\u5f8b\u578b\u732b\u30ed\u30dc\u30c3\u30c8",
                            "image": "post_Cat_allergen_adsorption_robot_trim.jpg",
                            "card_id": "P49",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#cleaning",
                                        "#room",
                                        "#well_being"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "\u82b1\u7c89\u75c7\u5bfe\u7b56\u5efa\u7bc9",
                            "value": 10,
                            "description": "\u5168\u3066\u306e\u30a4\u30f3\u30c6\u30ea\u30a2\u304c\u82b1\u7c89\u3092\u5438\u5f15\u3057\u30a2\u30ec\u30eb\u30ae\u30fc\u75c7\u72b6\u7121\u304f\u66ae\u3089\u3059\u3053\u3068\u304c\u3067\u304d\u308b\u5bb6",
                            "image": "post_Against_Pollinosis_Architecture_trim.jpg",
                            "card_id": "P50",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#cleaning",
                                        "#room",
                                        "#well_being"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ]
};